import { Box, Grid, Typography } from "@mui/material";
import { memo } from "react";
import { IGracePeriodCptCardProps } from "./models";
import DisplayDate from "../../../../DisplayDate";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const TRANSLATION_PATH = "page.beneficiaryGracePeriodCpt.";

export const GracePeriodCptCard = memo(({ data }: IGracePeriodCptCardProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={(t) => ({
        p: 2,
        width: "100%",
        backgroundColor: t.palette.grey[t.palette.mode === "light" ? 100 : 800],
        borderRadius: t.shape.borderRadius,
      })}
    >
      <Grid container spacing={2}>
        <Grid item xs={7} sm={9}>
          <Typography
            variant="subtitle2"
            sx={(t) => ({
              color: t.palette.grey[t.palette.mode === "light" ? 600 : 400],
            })}
          >
            {t(TRANSLATION_PATH + "description")}
          </Typography>
          <Typography>{data.description}</Typography>
        </Grid>
        <Grid item xs={5} sm={3}>
          <Typography
            variant="subtitle2"
            sx={(t) => ({
              color: t.palette.grey[t.palette.mode === "light" ? 600 : 400],
              lineHeight: 1.2,
            })}
          >
            {t(TRANSLATION_PATH + "unlock_date")}
          </Typography>
          <DisplayDate>{dayjs(data.unlockDate)}</DisplayDate>
        </Grid>
      </Grid>
    </Box>
  );
});
